// Step identifiers for the candidate profile wizard
export type WizardStepId = 'experience' | 'review';

// Static copy for a single wizard step
export interface WizardStepDefinition {
  id: WizardStepId;
  title: string;
  hint: string;
  guidance: string;
  meta: string;
  shieldNote: string;
}

// Page level heading and guidance (GitHub task #3)
export const PROFILE_HEADING_TITLE = 'Verify your work experience';
export const PROFILE_HEADING_SUBTITLE =
  'Add the roles you want verified, then provide a contact who can confirm each one.';

// Ordered wizard steps (GitHub task #4)
export const WIZARD_STEPS: readonly WizardStepDefinition[] = [
  {
    id: 'experience',
    title: 'Experience & references',
    hint: 'Add roles and reference contacts',
    guidance: 'Add each role you want verified, then add a reference contact for each one.',
    meta: 'Required',
    shieldNote: 'You’ll review all details before any request is sent.',
  },
  {
    id: 'review',
    title: 'Review & submit',
    hint: 'Check and send',
    guidance: 'Check your experience and reference contact details before submitting.',
    meta: 'Step 2 of 2',
    shieldNote: 'Nothing is sent until you confirm the final submission.',
  },
] as const;

export function getWizardStep(stepId: WizardStepId): WizardStepDefinition {
  return WIZARD_STEPS.find((step) => step.id === stepId) ?? WIZARD_STEPS[0]!;
}
